import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";

export default function TopicGrid() {
  return (
    <div className="grid h-full grid-cols-1 gap-3 sm:grid-cols-2">
      {topics.slice(0, 4).map((topic) => (
        <Link
          key={topic.id}
          to={`/search?q=${encodeURIComponent(topic.keyword)}`}
          className="group relative flex min-h-[156px] flex-col justify-end overflow-hidden rounded-lg border border-background-200/80 bg-background-100 p-4"
        >
          <img
            src={topic.image}
            alt={topic.title}
            title={`${topic.title} 专题策划`}
            className="absolute inset-0 h-full w-full object-cover opacity-45 transition-all duration-[900ms] group-hover:scale-105 group-hover:opacity-60"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/60 to-background-950/10"></div>
          <div className="relative z-10">
            <span className="mb-2 inline-flex items-center gap-1 rounded bg-primary-600/90 px-1.5 py-0.5 font-label text-[10px] tracking-wide text-background-50">
              {topic.tag}
            </span>
            <h3 className="font-heading text-[15px] font-semibold leading-snug text-foreground-950">{topic.title}</h3>
            <p className="mt-1 font-label text-[10.5px] tracking-wide text-foreground-500">{topic.subtitle}</p>
          </div>
          <i className="ri-arrow-right-up-line absolute right-3 top-3 text-foreground-500 transition-colors group-hover:text-primary-300"></i>
        </Link>
      ))}
    </div>
  );
}